export const ReportItems = [
  {
    label: 'Component',
    value: 'component',
  },
  {
    label: 'PL',
    value: 'pl',
  },
  {
    label: 'Trend',
    value: 'trend',
  },
  {
    label: 'WW WBR',
    value: 'wbr'
  },
  {
    label: 'HCP-Spot',
    value: 'hcp-spot'
  },
  {
    label: '13 Month Report',
    value: '13-month-report'
  },
  {
    label: 'Benchmark',
    value: 'benchmark'
  },
  {
    label: 'ASIN Metrics',
    value: 'asin-metrics'
  },
  {
    label: 'ASIN Metrics WW WBR',
    value: 'asin-metrics-ww-wbr'
  },
  {
    label: 'Bridging Report',
    value: 'bridging-factors'
  },
  {
    label: 'Forecast Attribution Report',
    value: 'forecast'
  },
  {
    label: 'FLCP Accuracy',
    value: 'flcp-accuracy'
  },
];

export const RollupItems = [
  {
    label: 'Worldwide',
    value: 'worldwide',
  },
  {
    label: 'Region',
    value: 'region',
  },
  {
    label: 'Marketplace',
    value: 'marketplace',
  },
];

export const RegionItems = [
  {
    label: 'NA',
    value: 'na',
  },
  {
    label: 'EU',
    value: 'eu',
  },
  {
    label: 'AP',
    value: 'fe',
  },
  {
    label: 'SA',
    value: 'sa',
  },
  {
    label: 'IN',
    value: 'in',
  },
  {
    label: 'MENA',
    value: 'mena',
  },
  {
    label: 'LATAM',
    value: 'latam',
  },
];

export const MarketplaceItems = [
  {
    label: 'US',
    value: '1',
    id: 'US',
  },
  {
    label: 'MX',
    value: '771770',
    id: 'MX',
  },
  {
    label: 'CA',
    value: '7',
    id: 'CA',
  },
  {
    label: 'UK',
    value: '3',
    id: 'UK',
  },
  {
    label: 'DE',
    value: '4',
    id: 'DE',
  },
  {
    label: 'FR',
    value: '5',
    id: 'FR',
  },
  {
    label: 'JP',
    value: '6',
    id: 'JP',
  },
  {
    label: 'ES',
    value: '44551',
    id: 'ES',
  },
  {
    label: 'NL',
    value: '328451',
    id: 'NL',
  },
  {
    label: 'IT',
    value: '35691',
    id: 'IT',
  },
  {
    label: 'CN',
    value: '3240',
    id: 'CN',
  },
  {
    label: 'AU',
    value: '111172',
    id: 'AU',
  },
  {
    label: 'TR',
    value: '338851',
    id: 'TR',
  },
  {
    label: 'SG',
    value: '104444012',
    id: 'SG',
  },
  {
    label: 'BR',
    value: '526970',
    id: 'BR',
  },
  {
    label: 'IN',
    value: '44571',
    id: 'IN',
  },
  {
    label: 'AE',
    value: '338801',
    id: 'AE',
  },
  {
    label: 'SA',
    value: '338811',
    id: 'SA',
  },
  {
    label: 'SE',
    value: '704403121',
    id: 'SE',
  },
  {
    label: 'PL',
    value: '712115121',
    id: 'PL',
  },
];

export const MarketplaceIdToLabel = MarketplaceItems.reduce((map, obj) => {
  map[obj.value] = obj.label;
  return map;
}, {});

export const ChannelItems = [
    {
        label: 'All',
        value: 'ALL',
        id: 'All',
    },
    {
        label: 'Retail',
        value: 'RETAIL',
        id: 'Retail',
    },
    {
        label: 'FBA',
        value: 'FBA',
        id: 'FBA',
    },
    {
        label: 'MFN',
        value: 'MFN',
        id: 'MFN',
    },
    {
        label: 'Warehouse Deals',
        value: 'WAREHOUSE_DEALS',
        id: 'WD'
    },
    {
        label: 'Amazon Global Stores',
        value: 'GLOBAL_STORES',
        id: 'AGS'
    },
    {
        label: 'Amazon Global Listings',
        value: 'GLOBAL_LISTINGS',
        id: 'AGL'
    },
    {
        label: 'Amazon Haul',
        value: 'HAUL',
        id: 'HAUL'
    },
];

export const ASINMetricChannelItems = [
  {
    label: 'Retail',
    value: 'RETAIL',
    id: 'Retail',
  },
  {
    label: 'FBA',
    value: 'FBA',
    id: 'FBA',
  },
  {
    label: 'MFN',
    value: 'MFN',
    id: 'MFN',
  },
];

export const Months = [
  {
    label: 'January',
    value: '01',
  },
  {
    label: 'February',
    value: '02',
  },
  {
    label: 'March',
    value: '03',
  },
  {
    label: 'April',
    value: '04',
  },
  {
    label: 'May',
    value: '05',
  },
  {
    label: 'June',
    value: '06',
  },
  {
    label: 'July',
    value: '07',
  },
  {
    label: 'August',
    value: '08',
  },
  {
    label: 'September',
    value: '09',
  },
  {
    label: 'October',
    value: '10',
  },
  {
    label: 'November',
    value: '11',
  },
  {
    label: 'December',
    value: '12',
  },
];

export const Years = [
  {
    label: '2017',
    value: '2017',
  },
  {
    label: '2018',
    value: '2018',
  },
  {
    label: '2019',
    value: '2019',
  },
  {
    label: '2020',
    value: '2020',
  },
];

export const Currency = [
  {
    label: 'USD',
    value: 'USD',
  },
  {
    label: 'EUR',
    value: 'EUR',
  },
  {
    label: 'Local MP',
    value: 'LOCAL',
  },
];

export const AccuracyTypes = [
  {
    label: 'First Answer',
    value: 'fa',
  },
  {
    label: 'Settled Answer',
    value: 'sa',
  }
];

export const SelectedTokenLimits = Object.freeze({
  MARKETPLACE: 3,
  PRODUCT_LINES: 3,
  TIME_FRAME: 3,
  DEFAULT: 3
});

export default {
  ReportItems,
  RollupItems,
  RegionItems,
  MarketplaceItems,
  ChannelItems,
  Months,
  Years,
  Currency,
  SelectedTokenLimits
};



// WEBPACK FOOTER //
// ./src/components/const/dropdown_elements.jsx